import { render, staticRenderFns } from "./warehouse_edit.vue?vue&type=template&id=4fd61b70&scoped=true"
import script from "./warehouse_edit.vue?vue&type=script&lang=js"
export * from "./warehouse_edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd61b70",
  null
  
)

export default component.exports